import { constants } from '..';

const setAdminsLoadingAction = flag => ({
  type: constants.admins.SET_ADMINS_LOADING,
  flag,
});

const setAssignableLocationsLoadingAction = flag => ({
  type: constants.admins.SET_ASSIGNABLE_LOCATIONS_LOADING,
  flag,
});

const setActivityRecordsLoadingAction = flag => ({
  type: constants.admins.SET_ACTIVITY_RECORDS_LOADING,
  flag,
});

const getAdminsAction = filter => ({
  type: constants.admins.GET_ADMINS,
  filter,
});

const getAssignableLocationsAction = () => ({
  type: constants.admins.GET_ASSIGNABLE_LOCATIONS,
});

const getActivityRecordsAction = (id, filter) => ({
  type: constants.admins.GET_ACTIVITY_RECORDS,
  id,
  filter,
});

const clearAdminsAction = () => ({
  type: constants.admins.CLEAR_ADMINS,
});

const setAdminsAction = (admins, count) => ({
  type: constants.admins.SET_ADMINS,
  admins,
  count,
});

const setAssignableLocationsAction = locations => ({
  type: constants.admins.SET_ASSIGNABLE_LOCATIONS,
  locations,
});

const setActivityRecordsAction = (records, total) => ({
  type: constants.admins.SET_ACTIVITY_RECORDS,
  records,
  total,
});

const addAdminAction = (body, history) => ({
  type: constants.admins.ADD_ADMIN,
  body,
  history,
});

const getAdminAction = id => ({
  type: constants.admins.GET_ADMIN,
  id,
});

const setAdminAction = admin => ({
  type: constants.admins.SET_ADMIN,
  admin,
});

const editAdminAction = (id, body, history) => ({
  type: constants.admins.EDIT_ADMIN,
  id,
  body,
  history,
});

const deactivateAdminAction = (id, newStatus) => ({
  type: constants.admins.DEACTIVATE_ADMIN,
  id,
  newStatus,
});

export const adminsActions = {
  setAdminsLoadingAction,
  setAssignableLocationsLoadingAction,
  setActivityRecordsLoadingAction,
  getAdminsAction,
  getAssignableLocationsAction,
  getActivityRecordsAction,
  clearAdminsAction,
  setAdminsAction,
  setAssignableLocationsAction,
  setActivityRecordsAction,
  addAdminAction,
  getAdminAction,
  setAdminAction,
  editAdminAction,
  deactivateAdminAction,
};
